export class FichaXConratacionXHi {

    nfichaxcontxhiId: number;
    nfichaxcontxhiIdfichaxcont: number;
    nfichaxcontxhiIdhi: number;
    cfichaxcontxhiDschi: string;
    cfichaxcontxhiFlgnuevo = 'NO';

    // hechoIrregular : ObraHechoIrregular;
    // obraPublicaPorHechoIrregular : ObraHechoIrregular;
}

